import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { OrganizationSearchModule } from '@features/organization-search/organization-search.module';
import { ApplicantComponent } from './applicant/applicant.component';
import { CreateEditApplicationModalComponent } from './create-edit-application-modal/create-edit-application-modal.component';
import { GrantProgramComponent } from './grant-program/grant-program.component';
import { OrganizationComponent } from './organization/organization.component';

@NgModule({
  imports: [
    GCCoreModule,
    OrganizationSearchModule
  ],
  declarations: [
    ApplicantComponent,
    CreateEditApplicationModalComponent,
    GrantProgramComponent,
    OrganizationComponent
  ],
  exports: [
    ApplicantComponent,
    CreateEditApplicationModalComponent,
    GrantProgramComponent,
    OrganizationComponent
  ]
})
export class OfflineGrantsCreateEditApplicationModule { }
